module.exports = __webpack_public_path__ + "static/media/commercial_cleaning.52fb1ed4.jpg";